export default "__VITE_ASSET__2d3d40ef__"